import { render } from "./ModuleResultView.vue?vue&type=template&id=67804113&scoped=true"
import script from "./ModuleResultView.vue?vue&type=script&lang=js"
export * from "./ModuleResultView.vue?vue&type=script&lang=js"

import "./ModuleResultView.vue?vue&type=style&index=0&id=67804113&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67804113"]])

export default __exports__